import {
	API_ERROR,
	PRODUCT_QUALITIES_ADD,
	GET_PRODUCT_QUALITIES_ROW_DATA,
	PRODUCTS_QUALITIES,
	PRODUCT_QUALITIES_DELETE,
	MODEL_OPEN,
	MODEL_CLOSE,
	PRODUCT_QUALITIES_LIST_SUCCESSFUL,
	PRODUCT_QUALITIES_ADD_SUCCESSFUL,
	PRODUCT_QUALITIES_ROW_SUCCESSFUL,
	SET_PARAMS,
	PRODUCT_QUALITY_EDIT_SUCCESSFUL,
	PRODUCT_QUALITY_EDIT,
	PRODUCT_QUALITY_SETROWDATA,
	PRODUCT_QUALITIES_CHANGEVALUE,
	PRODUCT_QUALITIES_SELECT_CHANGEVALUE,
} from "./actionTypes";

// Get all product qualities
export const getProductQualities = (data) => ({
	type: PRODUCTS_QUALITIES,
	payload: { data },
});

// Successful list fetch
export const ProductQualitiesListSuccessful = (products) => ({
	type: PRODUCT_QUALITIES_LIST_SUCCESSFUL,
	payload: products,
});
// Add product quality
export const ProductQualitiesAdd = (data, id, history) => ({
	type: PRODUCT_QUALITIES_ADD,
	payload: { data, id, history },
});

// Add successful
export const ProductQualitiesAddSuccessful = (response) => ({
	type: PRODUCT_QUALITIES_ADD_SUCCESSFUL,
	payload: response,
});

// Get row data
export const getProductQualitiesRowData = (id, history) => ({
	type: GET_PRODUCT_QUALITIES_ROW_DATA,
	payload: { id, history },
});

// Row success
export const ProductQualitiesRowSuccessful = (productQualities) => ({
	type: PRODUCT_QUALITIES_ROW_SUCCESSFUL,
	payload: productQualities,
});

// Delete product quality
export const ProductQualitiesDelete = (id, history) => ({
	type: PRODUCT_QUALITIES_DELETE,
	payload: { id, history },
});

// Modal open/close
export const modelOpen = () => ({ type: MODEL_OPEN });
export const modelClose = () => ({ type: MODEL_CLOSE });

// Set params
export const SetParams = (params) => ({
	type: SET_PARAMS,
	payload: params,
});

// API error
export const apiError = (error) => ({
	type: API_ERROR,
	payload: error,
});

export const qualityProductEdit = (data) => {
	return {
		type: PRODUCT_QUALITY_EDIT,
		payload: data,
	};
};

export const qualityProductEditSuccessful = (response) => {
	return {
		type: PRODUCT_QUALITY_EDIT_SUCCESSFUL,
		payload: response,
	};
};

export const SetEditData = (data) => {
	return {
		type: PRODUCT_QUALITY_SETROWDATA,
		payload: data,
	};
};

export const ProductQualitySelecteChangeValue = ({
	key,
	label,
	key2,
	value,
}) => {
	return {
		type: PRODUCT_QUALITIES_SELECT_CHANGEVALUE,
		payload: { key, label, key2, value },
	};
};

export const ProductQualityChangeValue = ({ key, value }) => {
	return {
		type: PRODUCT_QUALITIES_CHANGEVALUE,
		payload: { key, value },
	};
};
